import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';

class LoanLineForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            loan_line: null,
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const loanline_options = [{id:0 , name:'Capital de Trabajo'}, {id:1 , name:'Otra'}]

        return (

             <Section className="intro_form">
                <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_loan_line" description="Loanline Info"/>
                    <div className="show-desktop">
                        <SaveStepButton/>
                    </div>
                    </div>
                     <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.hasLoanLine)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="loan_line" defaultValue="Seleccioná la línea de crédito" label="Seleccioná la línea de crédito" attributeName='loan_line' attributeOptions={loanline_options}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                          <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

LoanLineForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

LoanLineForm = TopScrolleable(LoanLineForm);
let validate = generateValidator([{name: 'loan_line', required: true}]);

LoanLineForm = reduxForm({
    form: 'LoanLine', // a unique name for this form
    validate
})(LoanLineForm);

LoanLineForm = withAuthControl(LoanLineForm);

export default LoanLineForm;



/** WEBPACK FOOTER **
 ** ./src/components/LoanLineForm.js
 **/